import { endpointRegistry } from '@locus-taxy/encore-ui-network';

let registered = false;

export function registerFileEndpoints() {
  if (registered) return;
  endpointRegistry.registerEndpoints({
    'files.upload': {
      path: '/encore/api/v1/view/clients/:clientId/files',
      method: 'POST',
      requireAuth: true,
    },
    'files.get': {
      path: '/encore/api/v1/view/clients/:clientId/files/:fileId',
      method: 'GET',
      requireAuth: true,
    },
  });
  registered = true;
}
